import React from "react";
import { useTripLegs } from "../../hooks/useTripLegs";
import BookingSummary from "../../components/DashBoard/BookingSummary/BookingSummary";
import GoogleLoader from "../../assets/Loader/GoogleSvgLoader/GoogleLoader";

const TransportationServiceSetupSummaryContainer: React.FC = () => {
  const { tripLegs, selectedLeg, isLoading, creditCardDetails } = useTripLegs();

  return isLoading ? (
    <GoogleLoader />
  ) : (
    <BookingSummary
      trip={tripLegs}
      ccInfo={creditCardDetails}
      selectedLeg={selectedLeg}
    />
  );
};

export default TransportationServiceSetupSummaryContainer;
